export const BUTTON_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  STROKE: "STROKE",
} as const


export const TYPE_TITLE_IMAGE = {
  DEFAULT: "DEFAULT",
  ALTERNATIVE: "ALTERNATIVE"
} as const